import { Box, Grid, styled, Typography } from "@mui/material";
import * as React from "react";
import { Link } from "react-router-dom";
import { Footer } from "../../components/Footer/Footer";
import HeaderGeneral from "../../components/Header/HeaderGeneral";
import { PolicyNavGrid } from "./Components/PolicyNavGrid";

const ItemGrid = styled(Grid)({
  padding: "5%",
});

const NavGrid = styled(Grid)({
  height: "100%",
});

const BaseGrid = styled(Grid)({
  height: "100%",
  minHeight: "90vh",
});

const TitleText = styled(Typography)({
  paddingBottom: "2%",
});

export interface ITermsAndConditionPageProps {}

export function TermsAndConditionPage(props: ITermsAndConditionPageProps) {
  return (
    <Box>
      <HeaderGeneral />
      <BaseGrid container>
        <NavGrid container item sm={12} md={3}>
          <PolicyNavGrid />
        </NavGrid>
        <Grid container item sm={12} md={9}>
          <ItemGrid>
            <TitleText variant="h3">Terms And Conditions</TitleText>
            <br />
            <Typography variant="h4">Latar Belakang</Typography>
            <br />
            <Typography>
              website career.indomobil.co.id dan api-career.indomobil.co.id dan
              website, API, dokumentasi, server, dan semua kekayaan intelektual
              lainnya di operasikan dan di pelihara serta dimiliki oleh PT
              Indomobil Sukses Internasional.
            </Typography>
            <br />
            <Typography>
              Syarat Penggunaan ("<i>Terms And Conditions</i>") ini yang
              meliputi gabungan dari <i>Privacy Policy</i> di{" "}
              <Link
                style={{ color: "#00ACED" }}
                to="/Legal/PrivacyPolicy"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                career.indomobil.co.id/Legal/PrivacyPolicy
              </Link>{" "}
              , yang dimana merupakan kesepakatan antara perusahaan dengan anda
              sebagai user. Dengan menggunakan layanan Indomobil Career, anda
              setuju bahwa (i) anda berusia setara atau lebih dari 18 tahun,
              (ii) dan jika berusia setara atau lebih dari 18 tahun maka anda
              sudah membaca, mengerti, serta menerima ikatan dari Syarat
              Penggunaan ("<i>Terms And Conditions</i>") dan{" "}
              <i>Privacy Policy</i>.
            </Typography>
            <br />
            <Typography>
              Kami mempunyai hak untuk merubah <i>Terms And Conditions</i> kami
              sewaktu-waktu. Perubahan ini akan segera efektif setelah diumumkan
              pada halaman ini dan segala layanan serta produk yang anda gunakan
              akan membenarkan perjanjian yang sudah diubah. Anda setuju untuk
              membaca secara teliti versi terakhir dari{" "}
              <i>Terms And Conditions</i> yang diumumkan pada halaman ini.
            </Typography>
            <br />
            <Typography variant="h4">Jasa dan Batasan Penggunaan</Typography>
            <br />
            <Typography>
              Penggunaan layanan harus digunakan dengan tujuan yang sah. Anda
              wajib bertanggung jawab dan mentaati semua hukum yang berlaku
              terkait dengan penggunaan layanan Indomobil Career. Anda setuju
              untuk tidak melakukan hal-hal berikut:
            </Typography>
            <br />
            <ul>
              <li>
                <Typography>
                  Memasukan data pribadi yang tidak sesuai atau tidak
                  sebenar-benarnya (data palsu);
                </Typography>
              </li>
              <li>
                <Typography>
                  Mengganggu hak pengguna lain untuk menggunakan layanan
                  Indomobil Career;
                </Typography>
              </li>
              <li>
                <Typography>
                  Mengganggu layanan atau server atau jaringan yang terhubung
                  dengan layanan, atau tidak mematuhi persyaratan, prosedur,
                  kebijakan, ataupun regulasi dari hubungan yang terhubung
                  dengan layanan;
                </Typography>
              </li>
              <li>
                <Typography>
                  Mengunggah atau mengirimkan ataupun mencoba untuk mengirimkan
                  file yang berisikan Virus, Trojan Horse, Worms, Time Bombs,
                  Cancelbots, file atau data yang korup, ataupun perangkat lunak
                  yang mirip dan berpotensial untuk merusak jalannnya layanan
                  atau komputer pengguna lain;
                </Typography>
              </li>
              <li>
                <Typography>
                  Melanggar hukum atau aturan yang berlaku, ataupun mendukung
                  segala macam aktifitas ilegal yang tidak hanya meliputi
                  peretasan atau distribusi perangkat lunak palsu, atau
                  melakukan kecurangan atau peretasan pada layanan.
                </Typography>
              </li>
            </ul>
            <br />
            <Typography variant="h4">Privasi</Typography>
            <br />
            <Typography>
              Privasi anda sangat berharga bagi kami. <i>Privacy Policy</i> dari
              Indombil Career bisa dibaca pada halaman{" "}
              <Link
                style={{ color: "#00ACED" }}
                to="/Legal/PrivacyPolicy"
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                career.indomobil.co.id/Legal/PrivacyPolicy
              </Link>{" "}
              dan sesuai dengan yang sudah dijelaskan pada halaman{" "}
              <i>Privacy Policy</i>, tipe data yang kami kumpulkan dari anda dan
              perangkat anda (data pribadi), cara kami menggunakan data anda,
              dan juga dasar hukum bagaimana kami menggunakan data pribadi anda.
            </Typography>
            <br />
          </ItemGrid>
        </Grid>
      </BaseGrid>
      <Footer />
    </Box>
  );
}
